import {eTipoPermissao} from '@/enums/ePermissoes';
export default [
 {
  description: 'PatFormaTombamento',
  path: '/patrimonio/patformatombamento',
  name: 'patformatombamento',
  component: () => import('@/views/patrimonio/patformatombamento/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.FORMADETOMBAMENTONOVO_MENU_1200300399],
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Forma de Tombamento',
  path: '/patrimonio/patformatombamento/cadastro/:id?',
  parent: 'patformatombamento',
  name: 'patformatombamento_create',
  component: () => import('@/views/patrimonio/patformatombamento/InclusaoEdicao.vue'),
  meta: {
   permissions: [eTipoPermissao.FORMADETOMBAMENTONOVO_MENU_1200300399],
  },
  goesToMenu: true,
 },
]
